export default function policyMapReducer(
    state: any = {
        loading: false,
        done: false,
        response: null,
        error: null,
        success: null,
        updated: null,
    },
    action: any) {

    switch (action.type) {

        /**
         *     Policy map reducer
         */
        case 'FETCH_POLICY_MAP_PENDING': {
            return { ...state, loading: true, success: null }
        }

        case 'FETCH_POLICY_MAP_REJECTED': {
            return { ...state, loading: false, error: action.payload, success: false }
        }

        case 'FETCH_POLICY_MAP_FULFILLED': {
            return { ...state, loading: false, done: true, error: null, response: action.payload }
        }

        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/policyMap.ts